import type { IDeployment } from '@skystone/shared';
import { deploymentApi } from '@/services/deployment-api';
import { useApi } from '@/hooks/useApi';
import { DataTable, ErrorBanner, PageHeader, PageLoading } from '@/components/ui';
import type { ColumnDef } from '@/components/ui';
import { buildRawColumns, buildStandardEmptyMessage, buildStandardTblSubtitle } from '@/lib/tbl-page-utils';
import { PageContainer } from '@/components/layout';

const deploymentColumns: ColumnDef<IDeployment>[] = buildRawColumns<IDeployment>([
  { key: 'id', header: 'ID' },
  { key: 'deploymentKey', header: 'Deployment Key' },
  { key: 'repositoryId', header: 'Repository ID' },
  { key: 'repositoryName', header: 'Repository Name' },
  { key: 'fabricRepositoryId', header: 'Fabric Repository ID' },
  { key: 'productId', header: 'Product ID' },
  { key: 'productName', header: 'Product Name' },
  { key: 'environment', header: 'Environment' },
  { key: 'deploymentStatus', header: 'Deployment Status' },
  { key: 'sha', header: 'SHA' },
  { key: 'createdDate', header: 'Created Date' },
  { key: 'archived', header: 'Archived' },
  { key: 'archivedAt', header: 'Archived At' },
  { key: 'fabricSynced', header: 'Fabric Synced' },
  { key: 'fabricSyncedAt', header: 'Fabric Synced At' },
  { key: 'createdAt', header: 'Created At' },
  { key: 'updatedAt', header: 'Updated At' },
]);

export function TblDeploymentsPage() {
  const { data: rows, loading, error } = useApi(() => deploymentApi.getAll(), []);

  if (loading && !rows) {
    return <PageLoading />;
  }

  return (
    <PageContainer variant="wide" className="space-y-6">
      <PageHeader title="Tbl - deployments" subtitle={buildStandardTblSubtitle()} />
      <ErrorBanner message={error} />
      <DataTable
        data={rows ?? []}
        columns={deploymentColumns}
        keyExtractor={(row) => row.id}
        enablePagination
        enableFilters
        emptyMessage={buildStandardEmptyMessage('deployment')}
      />
    </PageContainer>
  );
}
